import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";
import "firebase/storage";
import "firebase/firestore";

var firebaseConfig = {
    apiKey: "AIzaSyBC2Oe5Kmqo2iD2rNbT74MYimSLqoG7qmc",
    authDomain: "referencekit-ordering.firebaseapp.com",
    databaseURL: "https://referencekit-ordering.firebaseio.com",
    projectId: "referencekit-ordering",
    storageBucket: "referencekit-ordering.appspot.com",
    messagingSenderId: "1006087177439",
    appId: "1:1006087177439:web:0ae3fa570b14d9fa9d556a",
    measurementId: "G-0VMZY6CY7Q"
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

const db = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();

const newsCollection = db.collection("news");
const emailCollection = db.collection("mail");
const usersCollection = db.collection("users");
const supportRequestCollection = db.collection("supportRequests");

export {
    db,
    auth,
    storage,
    newsCollection,
    emailCollection, 
    usersCollection,
    supportRequestCollection
}